import React from 'react'
import './ShippingTypeSelector.css'

export const SHIPPING_OPTIONS = [
  {
    code: "Normal",
    label: "Normal",
    price: 0,
    priceLabel: "GRATIS",
    description: null
  },
  {
    code: "Rápido con proposito",
    label: "Rápido con proposito",
    price: 6500,
    priceLabel: "$6,500",
    description: "Recíbelo rápido y regalas sonrisas: donas sandalias a un niño",
    image: "/path/to/regala-sonrisas.jpg" // Actualiza esta ruta según tu proyecto
  }
]

const ShippingTypeSelector = ({ shipping_type_code, onChange }) => {
  
  const handleChange = (code) => {
    // Simula el evento como lo hace InputForm
    const event = {
      target: {
        id: 'shipping_type_code',
        value: code
      }
    }
    onChange(event)
  }

  return (
    <div className="ShippingTypeSelector">
      <div className="ShippingTypeSelector_title">Opciones de envío</div>
      
      <div className="ShippingTypeSelector_options">
        {SHIPPING_OPTIONS.map((option) => (
          <label 
            key={option.code} 
            className={`ShippingTypeSelector_option ${shipping_type_code === option.code ? 'selected' : ''}`}
          >
            <div className="ShippingTypeSelector_radio">
              <input
                type="radio"
                name="shipping_type_code"
                value={option.code}
                checked={shipping_type_code === option.code}
                onChange={() => handleChange(option.code)}
              />
              <span className="ShippingTypeSelector_radioCustom"></span>
            </div>
            
            <div className="ShippingTypeSelector_content">
              <div className="ShippingTypeSelector_label">{option.label}</div>
              {option.description && (
                <div className="ShippingTypeSelector_description">
                  {option.description}
                </div>
              )}
            </div>
            
            <div className={`ShippingTypeSelector_price ${option.price === 0 ? 'free' : ''}`}>
              {option.priceLabel}
            </div>
          </label>
        ))}
      </div>

      {/* {shipping_type_code === "Rápido con proposito" && ( */}
        <div className="ShippingTypeSelector_banner">
          <img 
            src="https://cdn.shopify.com/s/files/1/0565/1880/3634/files/Casa_de_colombia_26_ago_2026_700px.webp?v=1788812617" 
            alt="Regala sonrisas" 
            className="ShippingTypeSelector_bannerImage"
          />
        </div>
      {/* )} */}
    </div>
  )
}

export default ShippingTypeSelector
